import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { VueCookieNext } from 'vue-cookie-next'
import lazyPlugin from 'vue3-lazy'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vue3Storage from "vue3-storage";
window.$ = window.jQuery = require('jquery');
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
import Paginate from "vuejs-paginate-next";
import { createMetaManager } from 'vue-meta'

// Safe circular reference detector - more efficient version
function hasCircularReference(obj, maxDepth = 10, depth = 0, seen = new WeakSet()) {
  if (depth > maxDepth) {
    console.warn('Maximum object depth exceeded, possible circular reference');
    return true;
  }
  
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  
  if (seen.has(obj)) {
    return true;
  }
  
  seen.add(obj);
  
  try {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && hasCircularReference(obj[key], maxDepth, depth + 1, seen)) {
        return true;
      }
    }
  } catch (e) {
    console.warn('Error checking circular reference:', e.message);
    return true;
  }
  
  seen.delete(obj);
  return false;
}

// Configure axios globally with safe transform
axios.defaults.transformResponse = [(data) => {
  try {
    const parsed = JSON.parse(data);
    
    // Check for circular references before returning
    if (hasCircularReference(parsed)) {
      console.warn('Circular reference detected in response data');
      return { error: 'Invalid response structure' };
    }
    
    return parsed;
  } catch (e) {
    console.warn('Failed to parse JSON response:', e.message);
    return data;
  }
}];

// Set safe defaults to prevent circular references
axios.defaults.timeout = 10000;
axios.defaults.maxRedirects = 5;

// Add global request interceptor to prevent circular references in request data
axios.interceptors.request.use(
  (config) => {
    if (config.data && hasCircularReference(config.data)) {
      console.warn('Circular reference detected in request data');
      return Promise.reject(new Error('Invalid request data structure'));
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const loadimage = require('./assets/img/Loading.gif')
const app = createApp(App);
app.use(router)
router.app = app
// Remove app.use(axios) - axios is not a Vue plugin
app.config.globalProperties.$http = axios // Optional: if you need axios globally
app.use(VueCookieNext)
app.use(Toast)
app.use(Vue3Storage, { namespace: "tag_" })
app.use(VueVideoPlayer)
app.use(createMetaManager())
app.use(Paginate)
app.use(lazyPlugin, {
    preLoad: 1.3,
    loading: loadimage,
    attempt: 1
})
app.mount('#app')

